import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    fetch: (config: AxiosRequestConfig) => api.get(`/payment/sellers`, config),
    fetchAll: (config: AxiosRequestConfig) =>
        api.get(`/payment/sellers/all`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/payment/sellers/${url.id}`, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/payment/sellers/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/payment/sellers/${url.id}`, data, config),
    sync: (data: object, config: AxiosRequestConfig) =>
        api.put(`/payment/sellers/sync`, undefined, config),
};

export default requests;
